import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { Sculpture } from './Sculpture';
import { Label } from './Label';
import { CALENDLY_URL, LINKEDIN_URL } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="grain relative isolate w-full overflow-hidden bg-navy pb-16 pt-24 sm:pb-20 sm:pt-28" data-id="element-96" data-mp="4m8l89fgoljc">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-97" data-mp="128yzkcr9hvyn">
        <div className="absolute left-5 top-0 h-full w-px bg-cream/10 sm:left-8" data-id="element-98" data-mp="xbflpdyh7l78" />
        <div className="absolute right-5 top-0 h-full w-px bg-cream/10 sm:right-8" data-id="element-99" data-mp="sai4b3laiv6s" />
        <div className="absolute inset-x-0 top-[62%] h-px bg-copper/25" data-id="element-100" data-mp="ncgjoe87unt7" />
      </div>

      <div className="relative mx-auto flex w-full max-w-[960px] flex-col px-5 sm:px-8" data-id="element-101" data-mp="3d1ik78o21amw">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="flex items-center gap-3" data-id="element-102" data-mp="3cz5v8bjvq00c">
          <span className="h-px w-10 bg-copper" data-id="element-103" data-mp="3o7lv7zxu9mt6" />
          <Label data-id="element-104" data-mp="3o73na61tdk5f">Business Consultant · Data &amp; AI · Paris</Label>
        </motion.div>

        <div className="mt-6 flex items-start justify-between gap-6 sm:gap-12" data-id="element-105" data-mp="399jmzcfv4d5l">
          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.06
        }} className="font-serif text-[3rem] italic leading-[0.96] tracking-[-0.01em] text-cream sm:text-[4.6rem]" data-id="element-106" data-mp="3e8mud3jbevgq">
            Bridging AI
            <br data-id="element-107" data-mp="2qlenwia5hgd4" />
            and <span className="text-copper" data-id="element-108" data-mp="2qhqvjmgfyzzz">Business</span>
          </motion.h1>

          <motion.div aria-hidden="true" initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.12
        }} className="pointer-events-none w-[84px] shrink-0 sm:w-[120px]" data-id="element-109" data-mp="2vjg50xo0n5ly">
            <Sculpture data-id="element-110" data-mp="s3md82jz5yyd" />
          </motion.div>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.12
      }} className="mt-8 max-w-xl font-sans text-base font-light leading-relaxed text-cream/75 sm:text-lg" data-id="element-111" data-mp="nat65811aej4">
          Data and AI strategy that lands in the business. I connect technical feasibility with
          finance, risk and operations, so a decision can actually be signed off.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.18
      }} className="mt-9 flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:gap-8" data-id="element-112" data-mp="112pz1eaj0sgk">
          <a href={CALENDLY_URL} target="_blank" rel="noreferrer noopener" className="group inline-flex items-center gap-3 bg-copper px-6 py-4 font-sans text-[11px] uppercase tracking-label text-navy transition-colors duration-200 ease-editorial hover:bg-copper-light" data-id="element-113" data-mp="3lquffqlsob64">
            Book a 30-minute AI strategy assessment
            <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-200 ease-editorial group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-114" data-mp="268of3uoojrxt" />
          </a>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer noopener" className="font-sans text-[11px] uppercase tracking-label text-cream/60 underline decoration-copper/50 underline-offset-8 transition-colors duration-200 ease-editorial hover:text-cream" data-id="element-115" data-mp="2fyr65pc8qvti">
            LinkedIn
          </a>
        </motion.div>
      </div>
    </section>;
}